import classnames from 'classnames';
import React from 'react';
import ArrowUp from './arrow-up.svg';
import styles from './styles.scss';

const tagsStyles = {
  1: styles.tg2Tag,
  2: styles.tg3Tag,
  3: styles.tg3Tag,
};

interface Props {
  mismatchNum: number;
  className?: string;
}

const TgMismatchIndicator = ({ mismatchNum, className }: Props): JSX.Element => {
  return (
    <div className={classnames(styles.tgMismatchContainer, className && className, tagsStyles[mismatchNum])}>
      <ArrowUp className={styles.arrowIndicator} />
    </div>
  );
};

export default TgMismatchIndicator;
